<app-viewer-header [file]="file">
  <div class="content text-secondary">
    <span class="info"><strong>ADDED:</strong> {{file?.createdTime | date | uppercase}}</span>
    <span class="info">|</span>
    <span class="info"><strong>BY:</strong> {{file?.author?.name | uppercase}}</span>
    <span class="info">|</span>
    <span class="info"><strong>SIZE:</strong> {{file?.size | fileSize: 'MB'}}</span>
  </div>
  <button *ngIf="canSetThumbnail"
    class="btn btn-sm ml-3"
    [ngClass]="thumbnailSetConfirmed ? 'btn-success' : 'btn-outline-light'"
    (click)="setAsThumbnail()"
    title="Set as Thumbnail">
    {{ thumbnailSetConfirmed ? '✓ Thumbnail Set!' : '★ Set as Thumbnail' }}
  </button>
  <app-asset-action
      [asset]="file"
      [type]="'dropdown'"
      class="file-action mr-4">
  </app-asset-action>
</app-viewer-header>
